import React, { Component, Fragment } from "react";
import config from "./../../../config/config.json";
import { Avatar, Tooltip, Icon, Table, TableHead, TableCell, TableRow, TableBody, CardContent, Typography, CardHeader, Card, IconButton, Container } from "@material-ui/core";
import { enabledPermissions } from "../../../services/enabledPermissions";
import AlertBox from "../../common/fields/AlertBox";
import { connect } from "react-redux";

const HEADERS = [
  { label: "Date", sm: '2-5' },
  { label: "Topic", sm: '1-5'},
  { label: "Description", sm: 3 },
  { label: "Data", sm: 4 },
  { label: "Actions", sm: 1 },
]

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
      userData: {},
      statusLogin: false,
      cards: [],
      responseForgot: "",
      responseLogin: "",
      openAlert: true,
      notificationsList: [],
      notificationsLoaded: true
    };
    this.headersSetCookie = window.localStorage.getItem("headersSetCookie");
  }


  UNSAFE_componentWillMount = async () => {

    let cardsPermited = [];
    if (window.localStorage.getItem("userData") !== null) {
      let permissionsItems = JSON.parse(window.localStorage.getItem("userData"))
        .roles;
      cardsPermited = enabledPermissions(config.cards, permissionsItems);
      this.setState({ statusLogin: true, cards: cardsPermited });
      this.setState({
        cards: enabledPermissions(config.cards, permissionsItems)
      });
    }

    this.setState({ cards: cardsPermited });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.resultsListNotifications !== this.props.resultsListNotifications) {
      const permissionsItems = JSON.parse(window.localStorage.getItem("userData")).roles;
      const newCards = enabledPermissions(config.cards, permissionsItems);

      const notificationsList = this.props.resultsListNotifications.map(notification => {
        return {
          ...notification,
          object_id: notification.object_id ? notification.object_id : false,
          module: notification.module ? (
            notification.module === "city" ? "destinations" :
            notification.module === "attraction" ? "attractions" :
            notification.module === "tour" ? "tours" :
            notification.module === "booking" ? "tourBookings" :
            false
          ) : false
        };
      });
      this.setState({
        cards: newCards,
        notificationsList: notificationsList
      });
    }
  }

  collapseAlert = () => {
    this.setState({ openAlert: false });
  };
  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  componentDidMount() {
    if (this.state.notificationsLoaded) {
      this.props.getNotifications(this.headersSetCookie);
      this.setState({ notificationsLoaded: false });
    }

    // Google Tag Manager
    const scriptGoogle = document.createElement("script");
    scriptGoogle.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${process.env.REACT_APP_GOOGLE_TAG_MANAGER}');`;
    document.head.appendChild(scriptGoogle);

    const noscriptGoogleTagManager = document.createElement("noscript");
    const iframe = document.createElement("iframe");
    iframe.src = "https://www.googletagmanager.com/ns.html?id="+ process.env.REACT_APP_GOOGLE_TAG_MANAGER;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    noscriptGoogleTagManager.appendChild(iframe);
    document.head.appendChild(noscriptGoogleTagManager);
  }

  TableListHead = props => {
    return (
      <TableHead>
        <TableRow className="MuiGrid-container">
          {HEADERS.map((headCell, i) => (
            <TableCell className={`MuiGrid-item MuiGrid-grid-xs-${headCell.sm}`} key={i}>
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };
  formatDate(dateString) {
    const date = new Date(dateString);
    const options = {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  }

  /*formatJson(data) {
    let result = "";

    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }
    }

    const entries = Object.keys(data).filter(key => key !== "id");

    entries.forEach((key, index) => {
      const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);

      if (key === "validFrom") {
        result += `${formattedKey}: ${this.formatDate(data[key])}`;
      } else if (key === "validTo") {
        result += ` - ${formattedKey}: ${this.formatDate(data[key])}`;
      } else {
        result += ` - ${formattedKey}: ${data[key]}`;
      }
    });

    if (result.startsWith(' - ')) {
      result = result.slice(3);
    }

    return result;
  }*/

    formatJson(data) {
      let rows = [];
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          return;
        }
      }

      const entries = Object.keys(data).filter(key => key !== "id");

      entries.forEach(key => {
        const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
        let value = key === "validFrom" || key === "validTo"
          ? this.formatDate(data[key])
          : data[key];
        rows.push({ name: formattedKey, value: value });
      });

      return (
        <table>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                <td style={{paddingRight: '20px'}}>{row.name}</td>
                <td>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

  render() {

    const GetMessageEmptyState = (props) => {
			return (
				<div className="empty-list no-documents">
					<Avatar className="large" color="secondary"><Icon>folder_open</Icon></Avatar>
					<Typography variant="body2"><span>There are no notification at the moment.</span></Typography>
				</div>
			)
		}

   return (
      <Fragment>

        <Container maxWidth={"xl"} className="container_Dashboard">
        <Card
          className="tableList tableList_paper card-box cardTableContainer"
          component="section"
        >

          <CardHeader
            className="card-header"
            style={{ height: "68.5px" }}
            title={
              <Typography
                className="toolbarTab_title"
                variant="h6"
                id="tableTitle"
              >
                Notifications
              </Typography>
            }
          />
           <CardContent className="Detail_Action_ViewContainer">

              <div className="tabPanels_container">

                  <Table
                      className="tableList_table"
                      aria-labelledby="tableTitle"
                      size="medium"
                      aria-label="enhanced table"
                    >
                      {this.state.notificationsList.length === 0 ?
                        <GetMessageEmptyState/>
                        :
                        <>
                          <this.TableListHead />
                          <TableBody>
                          {this.state.notificationsList !== undefined && this.state.notificationsList.map((row, index) => {
                                  let backgroundColor = '';
                            if (row.priority === 'critical') {
                              backgroundColor = '#ffcccc';
                            }

                            return (
                              <TableRow
                                className="MuiGrid-container"
                                hover
                                role="checkbox"
                                key={index}
                                style={{ backgroundColor }}
                              >
                                <TableCell id={1} style={{ userSelect: 'all' }} scope="row" className={`MuiGrid-item MuiGrid-grid-xs-${HEADERS[0].sm}`}>
                                  {this.formatDate (row.date)}
                                </TableCell>
                                <TableCell id={2} style={{ userSelect: 'all' }} scope="row" className={`MuiGrid-item MuiGrid-grid-xs-${HEADERS[1].sm}`}>
                                  {row.topic}
                                </TableCell>
                                <TableCell id={3} style={{ userSelect: 'all' }} scope="row" className={`MuiGrid-item MuiGrid-grid-xs-${HEADERS[2].sm}`}>
                                  {row.description}
                                </TableCell>
                                <TableCell id={4} style={{ userSelect: 'all' }} scope="row" className={`MuiGrid-item MuiGrid-grid-xs-${HEADERS[3].sm}`}>
                                  {this.formatJson(row.data)}
                                </TableCell>
                                <TableCell id={5} scope="row" className={`MuiGrid-item MuiGrid-grid-xs-${HEADERS[4].sm}`}>
                                {row.object_id && row.module && (
                                  <Tooltip title={`Go to ${row.module}`}>
                                      <a href={`/dashboard/${row.module}/show/${row.object_id}/#1`} target='_blank'>
                                      <IconButton>
                                        <Icon>open_in_new</Icon>
                                      </IconButton>
                                    </a>
                                  </Tooltip>
                                )}
                                  </TableCell>
                              </TableRow>
                            );
                          })}
                          </TableBody>
                        </> }
                  </Table>

              </div>

           </CardContent>
          </Card>

          {this.state.responseForgot !== "" && (
            <AlertBox
              text= {this.state.responseForgot}
              severity={'info'}
            />
          )}
          {this.state.responseLogin !== "" && (
            <AlertBox
            text=  {this.state.responseLogin}
            severity={'info'}
          />

         )}
        </Container>
      </Fragment>
    );
  }
}

const mapStateToProps = reducers => {
	return reducers.guidePortalReducer
};

const mapDispachToProps = dispatch => {
  return {
       getNotifications: (access) => dispatch({ type: "GET_NOTIFICATIONS", access })
  };
};
export default connect(
  mapStateToProps,
  mapDispachToProps
)(Dashboard);


